import {
    FORGOTPW_FAILD,
    FORGOTPW_LOADING,
    FORGOTPW_SUCCESS,
    FORGOTP_REMOVE,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    responseData: null
};

export const forgotPwReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case FORGOTPW_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case FORGOTPW_SUCCESS:
            console.log("here message success ",action.payload.message)
            return {
                ...state,
                loading: false,
                status: action.status,
                error: null,
                responseData: action.payload.message,
            };
        case FORGOTPW_FAILD:
            console.log("here message fail ",action.payload)
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.payload?.message,
                responseData: null,
            };
        case FORGOTP_REMOVE:
            return initialState
        default:
            return state;
    }
};




